module.exports = "/_next/static/images/logo-mobile-new-4e9d15958b7a6867da28934ba582f5e1.svg";